import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommentModerationComponent } from './comment-moderation/comment-moderation/comment-moderation.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CommentModerationComponent,
    RouterModule.forChild([
      {
        path: 'comments',
        component: CommentModerationComponent,
      },
    ]),
  ],
})
export class ModerationModule {}
